import React from 'react';
import Settings from './Settings';

export function TopNavSettings() {
  return <Settings />;
}

export default TopNavSettings;